const routes = [
  { path: '/404', name: '404', component: () => import('../views/404.vue'), hidden: true },
  { path: '*', redirect: '/404', hidden: true },
  { path: '/403', name: '403', component: () => import('../views/403'), hidden: true },
  {
    path: '/',
    name: 'home',
    redirect: '/prm/list',
    component: () => import('../views/Home.vue'),
    hidden: true,
    children: [
      {
        path: '/prm/list',
        name: 'list',
        meta: {
          activename: 'list'
        },
        component: () => import('../views/prm/PrmList.vue')
      },
      {
        path: '/prm/prmNew',
        name: 'prmNew',
        meta: {
          activename: 'prmNew'
        },
        component: () => import('../views/prm/PrmNew.vue')
      },
      {
        path: '/prm/PrmNewEBG',
        name: 'PrmNewEBG',
        meta: {
          activename: 'PrmNewEBG'
        },
        component: () => import('../views/prm/PrmNewEBG.vue')
      },
      {
        path: '/prm/dtl',
        name: 'prmDtl',
        meta: {
          activename: 'prmDtl'
        },
        component: () => import('../views/prm/PrmDtl.vue')
      },
      {
        path: '/prm/audit',
        name: 'prmAudit',
        meta: {
          activename: 'prmAudit'
        },
        component: () => import('../views/prm/PrmAudit.vue')
      },
      {
        path: '/prm/todoList',
        name: 'prmTodoList',
        meta: {
          activename: 'prmTodoList'
        },
        component: () => import('../views/prm/PrmTodoList.vue')
      },
      {
        path: '/prm/drafts',
        name: 'prmDraftsList',
        meta: {
          activename: 'prmDraftsList'
        },
        component: () => import('../views/prm/PrmDrafts.vue')
      },
      {
        path: '/prm/edit',
        name: 'prmEdit',
        meta: {
          activename: 'prmEdition'
        },
        component: () => import('../views/prm/PrmEdit.vue')
      },
      {
        path: '/prm/prmEditEBG',
        name: 'prmEditEBG',
        meta: {
          activename: 'prmEdition'
        },
        component: () => import('../views/prm/PrmEditEBG.vue')
      },
      {
        path: '/project/search',
        name: 'projectSearch',
        meta: {
          activename: 'projectSearch'
        },
        component: () => import('../views/prm/ProjectSearch.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      activename: 'login'
    },
    component: () => import('../views/Login.vue')
  },
  // {
  //   path: '/user/switch',
  //   name: 'switchUser',
  //   meta: {
  //     activename: 'switchUser'
  //   },
  //   component: () => import('../views/user/SwitchUser.vue')
  // },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/About.vue')
  }
  // {
  //   path: '/changeUser',
  //   name: 'changeUser',
  //   component: () => import('../views/changUser.vue')
  // }
  // {
  //   path: '/prm/new',
  //   name: 'prmNew',
  //   component: () => import('../views/prm/PrmNew.vue')
  // },
  // {
  //   path: '/prm/list',
  //   name: 'prmList',
  //   component: () => import('../views/prm/PrmList.vue')
  // },
  // {
  //   path: '/prm/dtl',
  //   name: 'prmDtl',
  //   component: () => import('../views/prm/PrmDtl.vue')
  // }
];

export default routes;
